import React from 'react';
//material
import {Card, withStyles, CardMedia, CardContent, CardActionArea} from '@material-ui/core';
import {Skeleton} from '@material-ui/lab';
//styles
import styles from './meeting-item-styles';
//library
import Moment from 'moment';
import { withRouter } from 'react-router-dom';

const MeetingItemView = (props) => {
  const {classes, meeting, isLoading, history, showMeetings} = props;
  const navigate = () =>
    history.push(showMeetings ? `meeting/${meeting.eventId}` : `event/${meeting.eventId}`);

  return (
    <Card>
      <CardActionArea disableRipple={isLoading} onClick={!isLoading ? navigate : null}>
        {
          isLoading ?
            <Skeleton variant={'rect'} height={165} /> :
            <CardMedia
              title={'Event Image'}
              image={meeting.imageUrl}
              className={classes.img}
            />
        }

        <CardContent className={classes.cardContent}>
          {
            isLoading ?
              <Skeleton height={24}/> :
              <div className={classes.name}>
                {meeting.eventName}
              </div>
          }

          {
            !isLoading && meeting.organisation &&
              <div className={classes.subtitle}>
                {meeting.organisation}
              </div>
          }

          {
            isLoading ?
              <Skeleton height={12} width={'40%'} /> :
              <div className={classes.subtitle}>
                {meeting.eventDate ? Moment(new Date(meeting.eventDate)).format('Do MMMM YYYY') : ''}
              </div>
          }

          {
            isLoading ?
              <Skeleton height={12} width={'40%'} /> :
              <div className={classes.course}>
                {meeting.clubName}
              </div>
          }
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default withRouter(withStyles(styles) (MeetingItemView));
